import * as Yup from "yup";

export const initialValuesEnrollment = {
    "description": ""
}

export const validationSchemaEnrollment = Yup.object().shape({
    "description": Yup.string().required('El nombre del concurso es requerido.')
})